/* ============================================================
   KyDeco — Product page interactions
   Gallery swap · accordion · quantity · variant price · sticky CTA
   ============================================================ */
(function () {
  function init(root) {
    if (!root || root.dataset.kdReady === '1') return;
    root.dataset.kdReady = '1';

    /* ---- Gallery: thumbnails + prev/next arrows swap the main image ---- */
    var main = root.querySelector('#kd-g-main');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('#kd-g-thumbs .g-thumb'));
    var gi = 0;
    thumbs.forEach(function (t, i) { if (t.classList.contains('active')) gi = i; });

    /* Warm only the current image's immediate neighbours so swaps feel instant —
       WITHOUT firing a full-size request for every photo on load, which flooded the
       connection on 20-50 photo listings and left most of the gallery broken. */
    var gUrls = thumbs.map(function (t) { return t.dataset.img; });
    function gPreload(u) { if (u) { var im = new Image(); im.decoding = 'async'; im.src = u; } }
    function warmNeighbors(i) {
      var n = gUrls.length; if (!n) return;
      gPreload(gUrls[(i + 1) % n]);
      gPreload(gUrls[(i - 1 + n) % n]);
    }
    warmNeighbors(gi);
    var gStrip = root.querySelector('#kd-g-thumbs');
    var gCount = root.querySelector('[data-kd-count]');
    function showImg(i) {
      if (!thumbs.length) return;
      gi = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      var t = thumbs[gi];
      t.classList.add('active');
      if (main && t.dataset.img) main.src = t.dataset.img;
      if (gCount) gCount.textContent = (gi + 1) + ' / ' + thumbs.length;
      warmNeighbors(gi);
      // Keep the active thumbnail in view within the strip (mobile)
      if (gStrip && gStrip.scrollWidth > gStrip.clientWidth + 4) {
        var tr = t.getBoundingClientRect();
        var sr = gStrip.getBoundingClientRect();
        gStrip.scrollTo({ left: gStrip.scrollLeft + (tr.left - sr.left) - (sr.width - tr.width) / 2, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showImg(i); }); });
    var gPrev = root.querySelector('#kd-g-prev');
    var gNext = root.querySelector('#kd-g-next');
    if (gPrev) gPrev.addEventListener('click', function () { showImg(gi - 1); });
    if (gNext) gNext.addEventListener('click', function () { showImg(gi + 1); });

    /* Wayfair-style gallery (2026-09-17): the page strip is capped (CSS hides
       thumbs past the cap). "+N more" opens the lightbox at that photo instead
       of expanding the page; the lightbox carries its own thumb strip (desktop)
       and a "n / N" counter (mobile). The two pair tiles under the main image
       just swap the main photo. */
    var gMore = root.querySelector('#kd-g-thumbs [data-kd-more]');
    if (gMore) gMore.addEventListener('click', function (e) {
      e.stopPropagation(); e.preventDefault();
      var btn = gMore.closest('.g-thumb');
      var at = Math.max(0, thumbs.indexOf(btn));
      var list = gUrls.filter(Boolean);
      if (!list.length) return;
      getZoom().open(list, at, function (i) { showImg(i); });
    });
    root.querySelectorAll('[data-kd-goto]').forEach(function (b) {
      b.addEventListener('click', function () {
        showImg(parseInt(b.dataset.kdGoto, 10) || 0);
        if (main && main.scrollIntoView) main.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });

    /* Click the main image (not the arrows) to open a zoomable view */
    if (main) {
      main.classList.add('is-zoomable');
      var mSuppress = false, mSX = 0, mSY = 0, mSwipe = false;
      main.addEventListener('click', function () {
        if (mSuppress) return;
        var list = thumbs.map(function (t) { return t.dataset.img; }).filter(Boolean);
        if (!list.length) list = [main.src];
        // opening at the current image; navigating in the zoom keeps the gallery in sync
        getZoom().open(list, gi, function (i) { showImg(i); });
      });
      // Mobile: swipe the main image to change picture (tap still opens zoom)
      main.addEventListener('touchstart', function (e) { var t = e.touches[0]; mSX = t.clientX; mSY = t.clientY; mSwipe = false; }, { passive: true });
      main.addEventListener('touchmove', function (e) {
        var t = e.touches[0], dx = t.clientX - mSX, dy = t.clientY - mSY;
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) mSwipe = true;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (!mSwipe) return;
        var dx = e.changedTouches[0].clientX - mSX;
        if (Math.abs(dx) > 40) showImg(dx < 0 ? gi + 1 : gi - 1);
        mSuppress = true; setTimeout(function () { mSuppress = false; }, 400);
      }, { passive: true });
    }

    /* ---- Measurements: description → Specifications (2026-09-17) ----
       The description is hidden from customers. Whatever measurements it holds
       (three formats in the catalog: a Measurement/Size table, a piece-per-row
       table for sets, or "Label: 47"" lines with bold group headers) are lifted
       into the spec table so nothing is lost. Width/Depth/Height from the tag
       are replaced when the description has a richer value (e.g. per-piece);
       everything else is inserted after them. */
    var dSrc = root.querySelector('[data-kd-desc-src]');
    var dTable = root.querySelector('[data-kd-spec-table]');
    if (dSrc && dTable) {
      var found = [];
      var SKIP = /^(measurements?|dimensions?|condition|value|delivery|notes?|item|piece)\b/i;
      var GENERIC = /^(size|value|inches|inch|in|measurements?|dimensions?|)$/i;
      function clean(v) {
        v = (v || '').replace(/\s+/g, ' ').trim().replace(/\s*(inches|inch|in)\.?$/i, '').replace(/["″”]+$/, '').trim();
        if (!v || v === '—' || v === '-') return '';
        return /^[\d\s.\/]+$/.test(v) ? v + '"' : v;
      }
      function isNum(v) { return /^\s*\d/.test(v || ''); }
      function isPureNum(v) { return /^\s*[\d.\/ ]+\s*(in|inches|")?\s*$/i.test(v || ''); }
      var pieces = false; // per-piece rows found → the generic W/D/H tag rows come out
      function cap(s) { s = s.replace(/\s+/g, ' ').trim(); return s.charAt(0).toUpperCase() + s.slice(1); }
      function add(label, value) {
        if (!label || !value) return;
        var key = label.toLowerCase().replace(/[^a-z0-9 ]/g, '').trim();
        for (var i = 0; i < found.length; i++) if (found[i].key === key) return;
        found.push({ label: cap(label), value: value, key: key });
      }
      Array.prototype.forEach.call(dSrc.querySelectorAll('table'), function (t) {
        var trs = Array.prototype.map.call(t.querySelectorAll('tr'), function (tr) {
          return Array.prototype.map.call(tr.children, function (c) { return c.textContent.replace(/\s+/g, ' ').trim(); });
        }).filter(function (r) { return r.length; });
        if (!trs.length) return;
        var head = trs[0];
        var dimCols = head.slice(1).some(function (h) { return /width|depth|height|length/i.test(h); });
        if (dimCols) {
          // piece per row: Item | Width | Depth | Height | Notes
          pieces = true;
          trs.slice(1).forEach(function (r) {
            var parts = [], extras = [];
            for (var i = 1; i < r.length; i++) {
              var h = (head[i] || '').replace(/\(.*?\)/g, '').trim(), v = clean(r[i]);
              if (!v) continue;
              if (/^width$/i.test(h)) parts.push(v + ' W');
              else if (/^depth$/i.test(h)) parts.push(v + ' D');
              else if (/^height$/i.test(h)) parts.push(v + ' H');
              else if (/^length$/i.test(h)) parts.push(v + ' L');
              else if (/^notes?$/i.test(h)) extras.push(r[i]);
              else extras.push(h.toLowerCase() + ' ' + v);
            }
            if (!parts.length && !extras.length) return;
            add(r[0] || 'Overall', parts.join(' × ') + (extras.length ? ' · ' + extras.join(' · ') : ''));
          });
        } else {
          // label per row, one or more value columns (e.g. 3 Seater | 2 Seater)
          var hasHeader = !!t.querySelector('th') || !isPureNum(head[1]);
          var cols = hasHeader ? head.slice(1).map(function (h) { return h.replace(/\(.*?\)/g, '').trim(); }) : [];
          var named = cols.length > 1 && cols.some(function (c) { return !GENERIC.test(c); });
          (hasHeader ? trs.slice(1) : trs).forEach(function (r) {
            var label = r[0];
            if (!label || SKIP.test(label)) return;
            var vals = [];
            for (var i = 1; i < r.length; i++) { var v = clean(r[i]); if (v) vals.push(named && cols[i - 1] ? v + ' (' + cols[i - 1] + ')' : v); }
            if (vals.length) add(label, vals.join(' · '));
          });
        }
      });
      if (!found.length) {
        // "Width: 47"" lines, optionally under a bold group header ("Ottoman").
        // Grouped lines collapse to one row per piece: Ottoman: 37" W × 32" D × 12" H
        var group = '', groups = [], gmap = {};
        Array.prototype.forEach.call(dSrc.querySelectorAll('p'), function (p) {
          p.innerHTML.split(/<br\s*\/?>/i).forEach(function (seg) {
            var tmp = document.createElement('div'); tmp.innerHTML = seg;
            var txt = tmp.textContent.replace(/\s+/g, ' ').trim();
            if (!txt) return;
            var m = txt.match(/^([^:]+?)\s*[:\-]\s*(\d[\d\s.\/]*)["″”]?\s*$/);
            if (m) {
              if (SKIP.test(m[1])) return;
              var lab = m[1].trim(), v = clean(m[2]);
              if (!group) { add(lab, v); return; }
              if (!gmap[group]) { gmap[group] = { parts: [], extras: [] }; groups.push(group); }
              var g = gmap[group];
              if (/^width$/i.test(lab)) g.parts.push(v + ' W');
              else if (/^depth$/i.test(lab)) g.parts.push(v + ' D');
              else if (/^height$/i.test(lab)) g.parts.push(v + ' H');
              else g.extras.push(lab.toLowerCase() + ' ' + v);
            } else if (!SKIP.test(txt) && txt.length < 40 && !/\d/.test(txt)) group = txt;
          });
        });
        if (groups.length) {
          pieces = true;
          groups.forEach(function (name) { var g = gmap[name]; add(name, g.parts.join(' × ') + (g.extras.length ? ' · ' + g.extras.join(' · ') : '')); });
        }
      }
      if (found.length) {
        var dims = { width: dTable.querySelector('dt[data-dim="width"]'), depth: dTable.querySelector('dt[data-dim="depth"]'), height: dTable.querySelector('dt[data-dim="height"]') };
        var anchor = dims.height || dims.depth || dims.width; // insert after the last tag row
        var after = anchor ? anchor.nextElementSibling : null; // its dd
        var insertBefore = after ? after.nextElementSibling : dTable.firstElementChild;
        if (pieces) {
          // a set: the tag's single W/D/H is just one of the pieces, drop it
          ['width', 'depth', 'height'].forEach(function (k) { var dt = dims[k]; if (dt) { var dd = dt.nextElementSibling; dTable.removeChild(dt); if (dd) dTable.removeChild(dd); dims[k] = null; } });
        }
        found.forEach(function (f) {
          if (dims[f.key]) { dims[f.key].nextElementSibling.textContent = f.value; return; }
          var dt = document.createElement('dt'), dd = document.createElement('dd');
          dt.textContent = f.label; dd.textContent = f.value;
          dTable.insertBefore(dt, insertBefore); dTable.insertBefore(dd, insertBefore);
        });
      }
    }

    /* Fade the bottom of the (desktop) gallery when more images are scrollable */
    var gallery = root.querySelector('.gallery');
    if (gallery) {
      var updateFade = function () {
        var scrollable = gallery.scrollHeight - gallery.clientHeight > 4;
        var atEnd = gallery.scrollTop + gallery.clientHeight >= gallery.scrollHeight - 4;
        gallery.classList.toggle('has-scroll', scrollable && !atEnd);
      };
      gallery.addEventListener('scroll', updateFade, { passive: true });
      window.addEventListener('resize', updateFade);
      updateFade();
      setTimeout(updateFade, 400); // re-check once images have laid out
    }

    /* ---- Accordion ---- */
    var acc = root.querySelector('[data-kd-acc]');
    if (acc) {
      var items = acc.querySelectorAll('.acc-item');
      var setH = function (item, open) {
        var a = item.querySelector('.acc-a');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
      };
      items.forEach(function (item) {
        if (item.classList.contains('open')) setH(item, true);
        item.querySelector('.acc-q').addEventListener('click', function () {
          var isOpen = item.classList.contains('open');
          items.forEach(function (o) { o.classList.remove('open'); setH(o, false); });
          if (!isOpen) { item.classList.add('open'); setH(item, true); }
        });
      });
      window.addEventListener('resize', function () {
        var open = acc.querySelector('.acc-item.open');
        if (open) setH(open, true);
      });
    }

    /* ---- Quantity ---- */
    var qVal = root.querySelector('#kd-q-val');
    var qInput = root.querySelector('#kd-q-input');
    var qMinus = root.querySelector('#kd-q-minus');
    var qPlus = root.querySelector('#kd-q-plus');
    if (qVal && qInput) {
      var setQty = function (n) {
        n = Math.max(1, n);
        qVal.textContent = n;
        qInput.value = n;
        if (qMinus) qMinus.disabled = n <= 1;
      };
      if (qMinus) qMinus.addEventListener('click', function () { setQty(parseInt(qInput.value, 10) - 1); });
      if (qPlus && !qPlus.disabled) qPlus.addEventListener('click', function () { setQty(parseInt(qInput.value, 10) + 1); });
    }

    /* ---- Variant select updates price + labels ---- */
    var select = root.querySelector('#kd-variant');
    if (select) {
      var addBtn = root.querySelector('#kd-add-cart');
      var elNow = root.querySelector('#kd-price-now');
      var elWas = root.querySelector('#kd-price-was');
      var elSave = root.querySelector('#kd-price-save');
      var elMo = root.querySelector('#kd-price-mo');
      var stickyB = document.querySelector('[data-kd-sticky] .ps-info b');
      select.addEventListener('change', function () {
        var o = select.options[select.selectedIndex];
        var now = o.dataset.now || '';
        if (elNow) elNow.textContent = now;
        if (elWas) { elWas.textContent = o.dataset.was || ''; elWas.style.display = o.dataset.was ? '' : 'none'; }
        if (elSave) elSave.style.display = o.dataset.save ? '' : 'none';
        if (elSave && o.dataset.save) elSave.innerHTML = elSave.innerHTML.replace(/You save.*/, 'You save ' + o.dataset.save);
        if (elMo) elMo.textContent = (o.dataset.mo || '') + '/mo';
        if (addBtn) {
          var avail = o.dataset.avail === 'true';
          addBtn.disabled = !avail;
          var prefix = addBtn.getAttribute('data-label-prefix') || 'Add to cart';
          addBtn.innerHTML = addBtn.querySelector('svg').outerHTML + ' ' + (avail ? (prefix + ' · ' + now) : 'Sold out');
        }
        if (stickyB) stickyB.childNodes[0].nodeValue = now + ' ';
      });
    }

    /* ---- Sticky mobile CTA ---- */
    var sticky = document.querySelector('[data-kd-sticky]');
    var form = document.querySelector('#kd-pdp-form');
    var addCart = root.querySelector('#kd-add-cart');
    if (sticky && addCart) {
      var onScroll = function () {
        var r = addCart.getBoundingClientRect();
        sticky.classList.toggle('show', r.bottom < 0);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      var sAdd = sticky.querySelector('[data-kd-sticky-add]');
      if (sAdd && form) sAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }

    /* ---- Add to cart -> open the theme's cart drawer (AJAX, no redirect) ---- */
    var drawer = document.querySelector('cart-drawer-component');
    if (form && drawer && !form.dataset.kdCartBound) {
      form.dataset.kdCartBound = '1';
      var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('#kd-add-cart');
        if (btn && btn.disabled) return;
        var fd = new FormData(form);
        // Ask the cart to re-render the sections that host the drawer line items
        var ids = [];
        document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
          var id = el.dataset.sectionId;
          if (id && ids.indexOf(id) === -1) ids.push(id);
        });
        if (ids.length) fd.append('sections', ids.join(','));
        if (btn) btn.disabled = true;
        var buttons = document.querySelectorAll('#kd-add-cart, [data-kd-sticky-add]');
        buttons.forEach(function (b) { b.disabled = true; });
        fetch(addUrl, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            buttons.forEach(function (b) { b.disabled = false; });
            if (res && res.status) {
              document.dispatchEvent(new CustomEvent('cart:error', {
                bubbles: true,
                detail: { sourceId: 'kd-pdp-form', data: { message: res.message, errors: res.errors, description: res.description } }
              }));
              return;
            }
            // Mirror the theme's CartAddEvent so cart-items morphs and the drawer auto-opens
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: res,
                sourceId: 'kd-pdp-form',
                data: {
                  source: 'product-form-component',
                  itemCount: Number(fd.get('quantity')) || 1,
                  productId: res && res.product_id,
                  sections: res && res.sections
                }
              }
            }));
          })
          .catch(function () {
            // Network failure: fall back to the native (redirecting) submit
            buttons.forEach(function (b) { b.disabled = false; });
            form.submit();
          });
      });
    }
  }

  /* ---- Image zoom lightbox (desktop: move to magnify · mobile: drag to pan) ---- */
  var _zoom = null;
  function getZoom() {
    if (_zoom) return _zoom;
    var ZOOM = 2.4;
    var svgL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>';
    var svgR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';
    var ov = document.createElement('div');
    ov.className = 'kd-zoom';
    ov.innerHTML = '<button type="button" class="kd-zoom-close" aria-label="Close">×</button>'
      + '<button type="button" class="kd-zoom-nav kd-zoom-prev" aria-label="Previous image">' + svgL + '</button>'
      + '<button type="button" class="kd-zoom-nav kd-zoom-next" aria-label="Next image">' + svgR + '</button>'
      + '<div class="kd-zoom-stage"><img alt=""></div>'
      + '<div class="kd-zoom-count" aria-live="polite"></div>'
      + '<div class="kd-zoom-thumbs" role="list"></div>';
    document.body.appendChild(ov);
    var strip = ov.querySelector('.kd-zoom-thumbs');
    var count = ov.querySelector('.kd-zoom-count');
    function thumbUrl(u) { return (u || '').replace(/([?&]width=)\d+/, '$1' + 160); }
    function buildStrip() {
      strip.innerHTML = '';
      urls.forEach(function (u, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'kd-zoom-thumb'; b.setAttribute('aria-label', 'View image ' + (i + 1));
        b.innerHTML = '<img src="' + thumbUrl(u) + '" alt="" loading="lazy">';
        b.addEventListener('click', function (e) { e.stopPropagation(); if (i !== idx) { idx = i; load(); if (onChange) onChange(idx); } });
        strip.appendChild(b);
      });
    }
    function mark() {
      count.textContent = urls.length ? (idx + 1) + ' / ' + urls.length : '';
      var kids = strip.children;
      for (var i = 0; i < kids.length; i++) kids[i].classList.toggle('active', i === idx);
      var a = kids[idx];
      if (a && strip.scrollWidth > strip.clientWidth + 4) {
        var ar = a.getBoundingClientRect(), sr = strip.getBoundingClientRect();
        strip.scrollTo({ left: strip.scrollLeft + (ar.left - sr.left) - (sr.width - ar.width) / 2, behavior: 'smooth' });
      }
    }
    var stage = ov.querySelector('.kd-zoom-stage');
    var img = ov.querySelector('img');
    var closeBtn = ov.querySelector('.kd-zoom-close');
    var prevBtn = ov.querySelector('.kd-zoom-prev');
    var nextBtn = ov.querySelector('.kd-zoom-next');
    var zoomed = false, dragging = false, moved = false, startX = 0, startY = 0, panX = 0, panY = 0;
    var swX = 0, swY = 0, swiping = false;
    var urls = [], idx = 0, onChange = null, loadToken = 0;

    function setZoomed(on) {
      zoomed = on; panX = 0; panY = 0;
      ov.classList.toggle('is-zoomed', on);
      img.style.transformOrigin = 'center center';
      img.style.transform = on ? 'scale(' + ZOOM + ')' : 'none';
    }
    function bigUrl(u) { return (u || '').replace(/([?&]width=)\d+/, '$1' + 2400); }
    function preloadBig(i) {
      if (urls.length < 2) return;
      i = (i + urls.length) % urls.length;
      var u = bigUrl(urls[i]);
      if (u) { var im = new Image(); im.decoding = 'async'; im.src = u; }
    }
    function load() {
      setZoomed(false);
      var std = urls[idx] || '';
      // show the already-cached standard image instantly, then upgrade to hi-res
      img.src = std;
      var big = bigUrl(std), my = ++loadToken;
      if (big && big !== std) {
        var hi = new Image();
        hi.onload = function () { if (my === loadToken) img.src = big; };
        hi.src = big;
      }
      // warm the neighbours so the next arrow/swipe is instant
      preloadBig(idx + 1); preloadBig(idx - 1);
      mark();
    }
    function go(d) {
      if (urls.length < 2) return;
      idx = (idx + d + urls.length) % urls.length;
      load();
      if (onChange) onChange(idx);
    }
    function open(list, startIndex, cb) {
      urls = list || []; idx = startIndex || 0; onChange = cb || null;
      buildStrip();
      load();
      ov.classList.add('open');
      ov.classList.toggle('has-nav', urls.length > 1);
      ov.classList.toggle('has-thumbs', urls.length > 1);
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      ov.classList.remove('open');
      document.documentElement.style.overflow = '';
    }
    // Fall back to the standard-size image if the 2400px source fails
    img.addEventListener('error', function () { var u = urls[idx]; if (u && img.src !== u) img.src = u; });
    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    ov.addEventListener('click', function (e) { if (e.target === ov || e.target === stage || e.target === strip || e.target === count) close(); });
    document.addEventListener('keydown', function (e) {
      if (!ov.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    });

    // Toggle zoom on click/tap (ignore the click that ends a pan drag)
    img.addEventListener('click', function (e) {
      e.stopPropagation();
      if (moved) { moved = false; return; }
      setZoomed(!zoomed);
    });
    // Desktop: move the pointer to magnify around that point
    ov.addEventListener('mousemove', function (e) {
      if (!zoomed) return;
      var r = stage.getBoundingClientRect();
      var px = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      var py = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
      img.style.transformOrigin = (px * 100) + '% ' + (py * 100) + '%';
    });
    // Mobile: drag to pan
    img.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      swX = t.clientX; swY = t.clientY; swiping = false; moved = false;
      if (zoomed) { dragging = true; startX = t.clientX - panX; startY = t.clientY - panY; }
    }, { passive: true });
    ov.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (zoomed && dragging) {
        // pan the zoomed image
        moved = true;
        panX = t.clientX - startX; panY = t.clientY - startY;
        var maxX = img.offsetWidth * (ZOOM - 1) / 2, maxY = img.offsetHeight * (ZOOM - 1) / 2;
        panX = Math.max(-maxX, Math.min(maxX, panX)); panY = Math.max(-maxY, Math.min(maxY, panY));
        img.style.transformOrigin = 'center center';
        img.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + ZOOM + ')';
        e.preventDefault();
      } else if (!zoomed) {
        // track a horizontal swipe to change image
        var dx = t.clientX - swX, dy = t.clientY - swY;
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) swiping = true;
      }
    }, { passive: false });
    img.addEventListener('touchend', function (e) {
      if (zoomed) { dragging = false; return; }
      if (swiping) {
        var dx = e.changedTouches[0].clientX - swX;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
        moved = true; // swallow the tap so it doesn't toggle zoom
      }
    });

    _zoom = { open: open };
    return _zoom;
  }

  function boot() { document.querySelectorAll('[data-kd-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-kd-pdp]');
    if (root) { root.dataset.kdReady = ''; init(root); }
  });

  /* ---- Deep-link chips: scroll to a spec dropdown and open it ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-kd-open-spec]') : null;
    if (!t) return;
    var handle = t.getAttribute('data-kd-open-spec');
    var item = handle && document.getElementById('kd-spec-' + handle);
    if (!item) return;
    e.preventDefault();
    var acc = item.closest('[data-kd-acc]');
    if (acc) {
      acc.querySelectorAll('.acc-item').forEach(function (o) {
        o.classList.remove('open');
        var a = o.querySelector('.acc-a'); if (a) a.style.maxHeight = '0px';
      });
      item.classList.add('open');
      var open = item.querySelector('.acc-a'); if (open) open.style.maxHeight = open.scrollHeight + 'px';
    }
    item.style.scrollMarginTop = '96px';
    item.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---- Reviews link: smooth-scroll to the review carousel ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a.rlink[href^="#"]') : null;
    if (!a) return;
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    target.style.scrollMarginTop = '80px';
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---- Condition tooltip: tap to toggle (mobile), click outside to close ---- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('.cond-trigger') : null;
    document.querySelectorAll('[data-kd-tip]').forEach(function (tip) {
      if (trigger && tip.contains(trigger)) {
        var open = !tip.classList.contains('is-open');
        tip.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      } else {
        tip.classList.remove('is-open');
      }
    });
  });
})();
